"use client";

import { useUserPlan } from "@/lib/hook/use-user-plan";
import { useUser } from "@clerk/nextjs";
import { createContext, useContext } from "react";

const AdsContext = createContext({ shouldShowAds: false, isPro: false });

export function AdsProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUser();
  const { data, isLoaded, isLoggedIn } = useUserPlan();

  const shouldShowAds =
    isLoaded &&
    (!isLoggedIn || (data?.id === user?.id && data?.plan === "FREE"));

  return (
    <AdsContext.Provider
      value={{
        shouldShowAds,
        isPro: isLoaded && data?.id === user?.id && data?.plan === "PRO",
      }}
    >
      {children}
    </AdsContext.Provider>
  );
}

export const useShouldShowAds = () => useContext(AdsContext).shouldShowAds;
export const useIsPro = () => useContext(AdsContext).isPro;
